// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:28:55

export default {
  "id": "feed-the-parrot",
  "slug": "feed-the-parrot",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/1d38ad75aab24f08b2a570c9d0d9e12e-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/1d38ad75aab24f08b2a570c9d0d9e12e/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Feed the Parrot",
      "description": "Hello! In this exciting game you will have to help the cute parrot to fill up on delicious fruit. Combine identical fruit tiles to clear the playing field and open new levels, compete with other players, enjoy the bright pixel art and comfortable puzzle difficulty level.  Each game session offers unique challenges and colorful backgrounds, creating an atmosphere of fun and relaxation - the game is perfect for relaxing after a long day at work. ",
      "instructions": "Collect three tiles with the same fruit in a glass, keep the glass full - this way you will get more points. If the glass is completely filled with tiles, you lose.",
      "genres": [
        "Mahjong & Connect"
      ],
      "tags": [
        "2d",
        "cute",
        "food",
        "relax",
        "sorting"
      ]
    },
    "zh-CN": {
      "title": "喂鹦鹉",
      "description": "你好！在这款激动人心的游戏中，你需要帮助可爱的小鹦鹉吃掉美味的果实。通过组合相同的水果拼图来清理游戏场地，开启新关卡，与其他玩家竞争，享受明亮的像素艺术和舒适的谜题难度。每次游戏都提供独特的挑战和多彩的背景，营造一个充满乐趣和放松的氛围——这款游戏是工作后放松的完美选择。",
      "instructions": "在玻璃杯中收集三个相同水果的瓷砖，保持玻璃杯满载——这样你将获得更多分数。如果玻璃杯完全被瓷砖填满，你将失败。",
      "genres": [
        "麻将 & 连接"
      ],
      "tags": [
        "2D",
        "可爱",
        "食物",
        "放松",
        "排序"
      ]
    },
    "zh-TW": {
      "title": "喂鳥啞啞",
      "description": "你好！在這款刺激的遊戲中，你將要幫助可愛的鳥兒吃滿美味的果實。將相同的果實圖片合併以清空遊戲場景並打開新關卡，與其他玩家競爭，享受明亮的像素藝術和舒適的謎題難度。每場遊戲都提供獨特的挑戰和色彩繽紛的背景，營造出歡樂放鬆的氣氛——遊戲是適合工作後放鬆的完美選擇。",
      "instructions": "在玻璃杯中收集三個相同水果的圖片，保持玻璃杯滿滿的 - 這樣你將獲得更多分數。如果玻璃杯完全被圖片填滿，你將會失敗。",
      "genres": [
        "麻將 & 連線"
      ],
      "tags": [
        "2D",
        "可愛",
        "食物",
        "放鬆",
        "分類"
      ]
    },
    "zh-HK": {
      "title": "喂鵝嘴鵰",
      "description": "你好！在這款刺激的遊戲中，你必須幫助可愛的鳥兒吃滿美味的水果。將相同的果實圖片合併，清空遊戲場地，開啟新關卡，與其他玩家競賽，享受亮麗的像素畫風和適中的謎題難度。每場遊戲都提供獨特的挑戰和色彩豐富的背景，營造出歡樂放鬆的氣氛——這款遊戲是工作後放鬆的完美選擇。",
      "instructions": "收集三塊同款水果的圖片，將玻璃杯填滿，這樣您可以獲得更多分數。如果玻璃杯完全被圖片填滿，您就會輸。",
      "genres": [
        "麻將 & 閃電連線"
      ],
      "tags": [
        "二維",
        "可愛",
        "食物",
        "放鬆",
        "分類"
      ]
    },
    "ja": {
      "title": "鳥を餌やる",
      "description": "こんにちは！この面白いゲームでは、可愛いカラスヤンに美味しい果物を食わせる手伝いをする必要があります。同じ果物のタイルを組み合わせてプレイフィールドをクリアし、新しいレベルを開放します。他のプレイヤーと競い合い、明るいピクセルアートと快適なパズルの難易度を楽しみましょう。各ゲームセッションはユニークな挑戦とカラフルな背景を提供し、楽しみとリラックスした雰囲気を作り出します。長い一日の仕事の後にリラックスするのに最適なゲームです。",
      "instructions": "ガラスに同じ果物のタイルを3枚集め、ガラスを満たすことで、より多くのポイントを獲得できます。ガラスが完全にタイルで満たされた場合、ゲームオーバーです。",
      "genres": [
        "麻雀＆コネクト"
      ],
      "tags": [
        "2D",
        "可愛い",
        "食事",
        "リラックス",
        "整理"
      ]
    },
    "ko": {
      "title": "파라rott에게 먹이를 주세요",
      "description": "안녕하세요! 이 흥미진진한 게임에서 귀여운 파도리를 맛있는 과일로 채우는 데 도움을 줘야 합니다. 같은 과일 타일을 조합하여 게임 필드를 비우고 새로운 레벨을 열어보세요. 다른 플레이어들과 경쟁하고, 밝은 픽셀 아트와 편안한 퍼즐 난이도를 즐겨보세요. 각 게임 세션은 독특한 도전과 다채로운 배경을 제공하여 즐거움과 휴식의 분위기를 조성합니다 - 일하다가 피로를 풀기에 완벽한 게임입니다.",
      "instructions": "컵에 같은 과일이 있는 타일을 세 개 모으고, 컵을 가득 채우면 더 많은 점수를 얻을 수 있습니다. 컵이 완전히 타일로 채워지면 패배합니다.",
      "genres": [
        "마작 & 커넥트"
      ],
      "tags": [
        "2D",
        "귀여운",
        "음식",
        "쉬는시간",
        "정렬"
      ]
    },
    "fr": {
      "title": "Nourrissez le perroquet",
      "description": "Bonjour ! Dans ce jeu captivant, vous devrez aider l'adorable perroquet à se remplir de fruits délicieux. Combinez des tuiles de fruits identiques pour libérer le champ de jeu et ouvrir de nouveaux niveaux, comprenez avec d'autres joueurs, profitez de l'art pixelé coloré et du niveau de difficulté de puzzle confortable. Chaque session de jeu propose des défis uniques et des arrière-plans colorés, créant une atmosphère de fun et de relaxation - le jeu est parfait pour se détendre après une longue journée de travail.",
      "instructions": "Collectez trois tuiles avec le même fruit dans un verre, gardez le verre plein - ainsi, vous obtiendrez plus de points. Si le verre est complètement rempli de tuiles, vous perdez.",
      "genres": [
        "Mahjong et Connect"
      ],
      "tags": [
        "2D",
        "mignon",
        "alimentation",
        "détente",
        "tri"
      ]
    }
  }
};
